import { render } from "./FbnFilingApproach.vue?vue&type=template&id=cc24a6a8"
import script from "./FbnFilingApproach.vue?vue&type=script&lang=js"
export * from "./FbnFilingApproach.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__